import { Grid2, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
// import socket from "../../../socket";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import OrderChat from "../../../../components/OrderChat";
import { useApp } from "../../../../contexts/AppContext";

export default function SystemOrderChat() {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate();
    const {translate} = useApp()

    const order_id = searchParams.get('order_id');

    if (!order_id) {
        navigate(-1)
        return null;
    }

    return (
        <Grid2 container flexDirection={'column'} height={'100%'} padding={1.5} gap={1}>
            <Grid2 container size='auto' justifyContent={'space-between'} alignItems={'center'}>
                <Grid2>
                    <Typography variant='h5' fontWeight={'bold'}>
                        {translate("Order Chat")}
                    </Typography>
                </Grid2>
                <Grid2>
                    <IconButton onClick={() => navigate('/system/orders/manage?order_id=' + order_id)}>
                        <Close />
                    </IconButton>
                </Grid2>
            </Grid2>
            <Grid2 size='grow'>
                <OrderChat order_id={Number(order_id)} />
            </Grid2>
        </Grid2>
    )
}
